import { Injectable } from '@angular/core';
import { HttpCustomService } from 'app/services/http-custom.service';

@Injectable()
export class BackupService {

    errorMessage = '';
    data = [];
    path = '';
    backupBaseUrl = 'backup/';

    constructor(
        private customHttpService: HttpCustomService,
    ) { }

    createBackup(callBackCreateBackup) {
        this.path = this.backupBaseUrl + 'create-backup/';
        this.customHttpService.fetchData(this.path, callBackCreateBackup);
    }

    backupList(callBackBackupList) {
        this.path = this.backupBaseUrl + 'list/';
        this.customHttpService.fetchData(this.path, callBackBackupList);
    }

    downloadBackup(backup_id, callBackDownloadBackup) {
        this.path = this.backupBaseUrl + backup_id + '/download/';
        this.customHttpService.fetchData(this.path, callBackDownloadBackup, true);
    }

    restoreBackup(backup_id, callBackRestoreBackup) {
        this.path = this.backupBaseUrl + backup_id + '/restore/';
        this.customHttpService.fetchData(this.path, callBackRestoreBackup);
    }

    uploadBackup(uploadData, callBackUploadBackup) {
        this.path = this.backupBaseUrl + 'upload-backup/';
        this.customHttpService.postData(uploadData, this.path, callBackUploadBackup, true);
    }

    deleteBackup(backup_id, callbackDelete) {
        this.path = this.backupBaseUrl + backup_id + "/delete/";
        this.customHttpService.deleteData(this.path, callbackDelete);
    }
}
